import { useTheme } from "@emotion/react";
import { Button, CircularProgress } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";

const LoginButton = ({ loading, text = "Log In" }) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        marginTop: "0",
      }}
    >
      <Button
        variant="contained"
        color="primary"
        type="submit"
        disabled={loading}
        sx={{
             boxShadow:"none",
          color: "#fff",
          borderRadius: "5px",
          padding: "14px",
          fontSize: "1rem",
          fontWeight:"600",
          textTransform: "none",
          justifyContent: "space-around",
            textAlign:"center",
          "&:hover": {
            backgroundColor: theme.palette.third.main,
             boxShadow:"none"
          },
        }}
      >
        {loading ? <CircularProgress size={24} color="inherit" /> : text}
      </Button>
    </Stack>
  );
};

export default LoginButton;
